<template>
  <div>
    <a
      class="btn btn-link text-black-50 font-weight-bold text-decoration-none p-0 justify-content-end"
      :href="link.url"
    >
      <i class="fas fa-arrow-left fa-sm text-black-40 align-baseline" />
      {{ link.text }}
    </a>
  </div>
</template>

<script setup>
import whiteLabelConfigQuery from "@/apps/whiteLabelWebsite/whiteLabel/core/application/bridge/query/configQuery";

const link = whiteLabelConfigQuery.getConfig().externalWebsiteLink;
</script>
